<form class="search-nav-item">
    <p-autoComplete (completeMethod)="search($event)" (onSelect)="onSelect($event)" [(ngModel)]="searchMenu"
                    [suggestions]="resultsMenu" field="label" name="search"
                    [placeholder]="'CORE.HEADER.NAVBAR.SEARCH_NAV' | translate"></p-autoComplete>
</form>
